<template>
  <div>
    <header class="head">
      <div class="main-bar">
        <div class="row">
          <div class="col-lg-6 col-sm-4">
            <h4 class="nav_top_align text-dark font-weight-bold">
              <i class="fa fa-user" aria-hidden="true"></i> &nbsp; แก้ไขโปรไฟล์
            </h4>
          </div>
        </div>
      </div>
    </header>
    <div class="outer">
      <div class="inner bg-container">
        <div class="card card-csq no-shadow rounded-0">
          <div class="card-header border-bottom-0">
            <router-link :to="{ name: 'member.index' }" class="text-csq lead">
              <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
            </router-link>
            <span class="lead">
              {{ member.firstName }} {{ member.lastName }}
            </span>
            <span
              v-if="isWannasorn && registerDateText"
              class="float-right text-muted"
            >
              วันที่ลงทะเบียน {{ registerDateText }}
            </span>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-lg-3 m-t-25">
                <div
                  class="card bg-dark text-white mb-3 no-shadow"
                  style="max-width: 240px; margin: auto"
                >
                  <img :src="member.avatarUrl" class="card-img" alt />
                  <label
                    v-if="isWannasorn"
                    class="btn btn-dark text-light border-0 mb-0"
                    :class="{ disabled: isUploadingProfileImage }"
                  >
                    <i class="fa fa-camera text-csq" aria-hidden="true"></i>
                    {{
                      isUploadingProfileImage
                        ? "กำลังอัปโหลด..."
                        : "แก้ไขรูปโปรไฟล์"
                    }}
                    <input
                      type="file"
                      accept="image/jpeg,image/png"
                      hidden
                      :disabled="isUploadingProfileImage"
                      @change="onProfileImageSelected"
                    />
                  </label>
                  <button
                    v-else
                    class="btn btn-dark text-light border-0"
                    v-show="false"
                  >
                    แก้ไขรูปภาพ
                    <i class="fa fa-pen text-csq" aria-hidden="true"></i>
                  </button>
                </div>

                <div class="card border-0 bg-light mb-3 no-shadow">
                  <div class="card-header border-0 bg-transparent">
                    <h5 class="card-title">กลุ่ม</h5>
                  </div>
                  <div class="card-body pb-0">
                    <v-select
                      v-model="memberGroups"
                      multiple
                      :options="companyGroups"
                      label="name"
                      placeholder="เลือกกลุ่ม"
                      @input="setSelectedGroups"
                    ></v-select>
                  </div>
                  <div class="card-footer border-top-0 bg-light">
                    <button
                      class="btn btn-dark"
                      type="button"
                      @click="syncMemberGroups"
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              </div>
              <b-tabs content-class="mt-3" style="width: 70%">
                <b-tab title="ข้อมูลผู้เรียน" active>
                  <div>
                    <WannasornMemberEditForm
                      v-if="isWannasorn"
                      :member="member"
                      :errors="errors"
                      @patched="patch"
                      @passwordChanged="updatePassword"
                    ></WannasornMemberEditForm>
                    <member-form
                      v-else
                      :member="member"
                      :errors="errors"
                      @patched="patch"
                      @passwordChanged="updatePassword"
                    ></member-form>
                  </div>
                </b-tab>
                <b-tab title="รูปสำหรับยืนยันตัวตน" v-if="isWannasorn">
                  <WannasornIdCardTab />
                </b-tab>
                <b-tab
                  title="ผู้ทำบัญชี/ผู้สอบบัญชี"
                  v-if="isAllowedToSpecificCompany('special-membership')"
                >
                  <TfacTab
                    :specialMembership="specialMembership"
                    @updated="updateSpecialMembership"
                  />
                </b-tab>
                <b-tab
                  title="ที่อยู่การชำระเงิน"
                  v-if="isAccountingType() || isAllowedToSpecificCompany('payment-address-tab')"
                >
                  <PaymentAddressTab
                    v-if="paymentAddresssTabStat == null"
                    :billingAddressList="billingAddressList"
                    :shippingAddressList="shippingAddressList"
                    @addNewBillingAddress="addNewBillingAddress"
                    @editBillingAddress="editBillingAddress"
                    @addNewShippingAddress="addNewShippingAddress"
                    @editShippingAddress="editShippingAddress"
                    @backPaymentAddressList="backPaymentAddressList"
                  />
                  <BillingAddressFormTab
                    v-if="paymentAddresssTabStat == 'billingAddressForm'"
                    :memberId="memberId"
                    :billingAddress="billingAddress"
                    @backPaymentAddressList="backPaymentAddressList"
                  />
                  <ShippingAddressFormTab
                    v-if="paymentAddresssTabStat == 'shippingAddressForm'"
                    :memberId="memberId"
                    :shippingAddress="shippingAddress"
                    @backPaymentAddressList="backPaymentAddressList"
                  />
                </b-tab>
                <b-tab
                  title="ข้อมูลตัวแทน/นายหน้า"
                  v-if="isInsuranceType()"
                >
                  <InsuranceTab
                    :firstName="member.firstName"
                    :lastName="member.lastName"
                  />
                </b-tab>
                <b-tab
                  title="อัปโหลดรูปสำหรับยืนยันตัวตน"
                  v-if="isInsuranceType() || isAllowedToSpecificCompany('img-upload-tab')"
                >
                  <ImgUploadTab />
                </b-tab>
              </b-tabs>
            </div>
          </div>
          <div class="card-footer border-top-0">
            <router-link :to="{ name: 'member.index' }" class="text-csq">
              <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
              ย้อนกลับ
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import MemberForm from "./shared/Form.vue";
import WannasornMemberEditForm from "./shared/WannasornMemberEditForm.vue";
import WannasornIdCardTab from "./shared/WannasornIdCardTab.vue";
import TfacTab from "./shared/TfacTab.vue";
import ImgUploadTab from "./shared/ImgUploadTab.vue";
import InsuranceTab from "./shared/InsuranceTab.vue";
import PaymentAddressTab from "./shared/PaymentAddressTab.vue";
import BillingAddressFormTab from "./shared/BillingAddressFormTab.vue";
import ShippingAddressFormTab from "./shared/ShippingAddressFormTab.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import api from "../../../services/api";
import uploadService from "@/services/upload-service";
import authMixin from "@/mixins/auth-mixin.js";
import { isWannasornCompany } from "@/helpers/wannasorn";

export default {
  components: { MemberForm, WannasornMemberEditForm, WannasornIdCardTab, vSelect, ImgUploadTab, InsuranceTab, TfacTab, PaymentAddressTab, BillingAddressFormTab, ShippingAddressFormTab },
  props: { company: { type: Object, default: null } },
  mixins: [authMixin],

  computed: {
    isWannasorn() {
      return isWannasornCompany(this.comId);
    },
    // Registration date shown in the header, e.g. "23 พ.ย. 2025" (Gregorian year, per the design).
    registerDateText() {
      if (!this.member.registerDate) return "";
      const months = [
        "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.",
        "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค.",
      ];
      const m = moment(String(this.member.registerDate));
      if (!m.isValid()) return "";
      return `${m.date()} ${months[m.month()]} ${m.year()}`;
    },
  },

  data() {
    return {
      comId: this.$store.state.Company.companyInfo.id,
      memberId: this.$route.params.id,
      companyUrl: this.$route.params.company,
      member: {
        firstName: null,
        lastName: null,
        firstNameEn: null,
        lastNameEn: null,
        email: null,
        phoneNumber: null,
        avatarUrl: "https://s1.coursesquare.co/data/images/display.jpg",
        companies: [],
        dateOfBirth: null,
        department: null,
        groups: [],
        idCard: null,
        username: null,
        staffId: null,
        idCardExpireDate: null,
        preferredUniversity: null,
        preferredFaculty: null,
        education: null,
        // Extended learner fields (Wannasorn) — null so FormInputText renders the read-only + pencil view
        studentId: null,
        firstNameTh: null,
        lastNameTh: null,
        nickName: null,
        gradeLevel: null,
        gender: null,
        parentPhone: null,
        address: null,
        subDistrict: null,
        district: null,
        province: null,
        postcode: null,
        disabled: null,
        lockReason: null,
      },
      specialMembership: {
        sm_membershipId: null,
        sm_cpaNo: null,
        sm_dbdStatus: null,
      },
      paymentAddresssTabStat: null,
      billingAddress: {},
      billingAddressList: [],
      shippingAddress: {},
      shippingAddressList: [],
      memberGroups: [],
      companyGroups: [],
      selectedGroups: [],
      errors: {},
      isUploadingProfileImage: false,
    };
  },

  mounted() {
    this.getMember();
    this.getSpecialMembership();
    this.getMemberBillingAddress();
    this.getMemberShippingAddress();
    this.getMemberGroups();
    this.getCompanyGroups();
  },

  methods: {
    async getMember() {
      await api
        .get(`/v1/members/${this.memberId}`)
        .then(({ data }) => {
          this.member = data.data;
        })
        .catch(() => {});
    },

    async onProfileImageSelected(event) {
      const file = event.target.files[0];
      event.target.value = "";
      if (!file) return;

      const validTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validTypes.includes(file.type)) {
        this.$bvToast.toast("โปรดเลือกไฟล์ .jpg .jpeg .png เท่านั้น", {
          variant: "danger",
          autoHideDelay: 3000,
          noCloseButton: true,
          solid: true,
        });
        return;
      }
      if (file.size > 3 * 1024 * 1024) {
        this.$bvToast.toast("ขนาดไฟล์ต้องไม่เกิน 3MB", {
          variant: "danger",
          autoHideDelay: 3000,
          noCloseButton: true,
          solid: true,
        });
        return;
      }

      this.isUploadingProfileImage = true;
      try {
        await uploadService.uploadProfileImage({
          memberId: this.memberId,
          comId: this.comId,
          imageFile: file,
        });
        const localPreview = URL.createObjectURL(file);
        this.member.avatarUrl = localPreview;
        await this.getMember();
        if (this.member.avatarUrl) {
          this.member.avatarUrl += (this.member.avatarUrl.includes('?') ? '&' : '?') + 't=' + Date.now();
        }
        this.$bvToast.toast("อัปเดตรูปโปรไฟล์เรียบร้อยแล้ว.", {
          variant: "success",
          autoHideDelay: 3000,
          noCloseButton: true,
          solid: true,
        });
      } catch (error) {
        this.$bvToast.toast("อัปโหลดรูปโปรไฟล์ไม่สำเร็จ.", {
          variant: "danger",
          autoHideDelay: 3000,
          noCloseButton: true,
          solid: true,
        });
      } finally {
        this.isUploadingProfileImage = false;
      }
    },
    async getSpecialMembership() {
      await api
        .get(`/v1/special-membership/${this.memberId}`)
        .then(({ data }) => {
          this.specialMembership = data.data;
        })
        .catch(() => {});
    },
    async getMemberBillingAddress() {
      await api
        .get(`/v1/members/${this.memberId}/billing-address`)
        .then(({ data }) => {
          this.billingAddressList = data;
        })
        .catch(() => {});
    },
    async getMemberShippingAddress() {
      await api
        .get(`/v1/members/${this.memberId}/shipping-address`)
        .then(({ data }) => {
          this.shippingAddressList = data;
        })
        .catch(() => {});
    },

    getCompanyGroups() {
      api
        .get(`/v1/companies/${this.company.id}/member-groups`)
        .catch(({ response }) => {
          console.error(response);
        })
        .then(({ data }) => {
          this.companyGroups = data.data;
        });
    },

    getMemberGroups() {
      api
        .get(`/v1/members/${this.memberId}/groups?com_id=${this.company.id}`)
        .catch(({ response }) => {
          console.error(response);
        })
        .then(({ data }) => {
          this.memberGroups = data.data;
        });
    },

    setSelectedGroups() {
      this.selectedGroups = this.memberGroups.map((x) => x.id);
    },

    async update(data) {
      await api
        .put(`/v1/members/${this.memberId}?company=${this.company.id}`, data.member)
        .then(() => {
          this.$bvToast.toast("บันทึกข้อมูลเรียบร้อยแล้ว.", {
            variant: "success",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });

          this.isEditing = false;
        })
        .catch(({ response }) => {
          if (response.status == 422 && data.inputName == 'email') {
            alert('อีเมลนี้ถูกใช้ไปแล้ว กรุณาใช้อีเมลอื่น')
          }
          const result = JSON.parse(response.request.response);
          this.errors = result.errors;
          this.$toast.error(response.data.message, "Error", {
            timeout: 3000,
          });
          return false;
        });
    },

    async patch(data) {
      let payload = { [data.name]: data.value };

      await api
        .patch(`/v1/members/${this.memberId}?company=${this.company.id}`, payload)
        .then(() => {
          this.$bvToast.toast("บันทึกข้อมูลเรียบร้อยแล้ว.", {
            variant: "success",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });

          this.isEditing = false;
        })
        .catch(({ response }) => {
          // Restore the value shown before the rejected edit (e.g. an invalid ID card number).
          if (data.previousValue !== undefined) {
            this.member[data.name] = data.previousValue;
          }
          const result = JSON.parse(response.request.response);
          this.errors = { ...this.errors, ...result.errors };
          this.$bvToast.toast(response.data.message, {
            variant: "danger",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });
          return false;
        });
    },
    async updateSpecialMembership(data) {
      await api
        .put(`/v1/special-membership/${this.memberId}`, data)
        .then(() => {
          this.$bvToast.toast("บันทึกข้อมูลเรียบร้อยแล้ว.", {
            variant: "success",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });

          this.isEditing = false;
        })
        .catch(({ response }) => {
          const result = JSON.parse(response.request.response);
          this.errors = result.errors;
          this.$toast.error(response.data.message, "Error", {
            timeout: 3000,
          });
          return false;
        });
    },

    updatePassword(data) {
      api
        .put(
          `/v1/members/${this.memberId}/password/?company=${this.company.id}`,
          {
            password: data.password,
            password_confirmation: data.passwordConfirm,
          }
        )
        .then(() => {
          this.$bvToast.toast("เปลี่ยนรหัสผ่านเรียบร้อยแล้ว.", {
            variant: "success",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });

          this.isEditing = false;
        })
        .catch(() => {
          this.$bvToast.toast("เปลี่ยนรหัสผ่านไม่สำเร็จ.", {
            variant: "danger",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });
          return false;
        });
    },

    syncMemberGroups() {
      api
        .post(`/v1/members/${this.memberId}/groups`, {
          groups: this.selectedGroups,
        })
        .catch(() => {
          this.$toast.error("ไม่สามารถบันทึกข้อมูลได้!", "Error", {
            timeout: 3000,
          });
        })
        .then(() => {
          this.$bvToast.toast("บันทึกข้อมูลเรียบร้อยแล้ว.", {
            variant: "success",
            autoHideDelay: 3000,
            noCloseButton: true,
            solid: true,
          });

          this.selectedGroups = [];
        });
    },
    async addNewBillingAddress() {
      this.billingAddress = null;
      this.paymentAddresssTabStat = "billingAddressForm";
    },
    async editBillingAddress(data) {
      this.paymentAddresssTabStat = "billingAddressForm";
      this.billingAddress = data;
    },
    async addNewShippingAddress() {
      this.shippingAddress = null;
      this.paymentAddresssTabStat = "shippingAddressForm";
    },
    async editShippingAddress(data) {
      this.paymentAddresssTabStat = "shippingAddressForm";
      this.shippingAddress = data;
    },
    async backPaymentAddressList() {
      await this.getMemberBillingAddress();
      await this.getMemberShippingAddress();
      this.paymentAddresssTabStat = await null;
    },
  },
};
</script>
